import React from 'react';

import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';

interface HeaderProps {
  children: React.ReactNode | string;
  className?: string;
}

function Header(props: HeaderProps) {
  const { children, className } = props;
  return (
    <Typography className={cn(className, 'mb-12 flex')} variant="heading-m">
      {children}
    </Typography>
  );
}

export default React.memo(Header);
